/**
 * Fonte única de URLs RPC por chainId.
 * Consumido por publicRpcReadOnly e WalletConnectionContext.
 */
import { normalizeChainId } from '@/utils/networkSync';

const INFURA_API_KEY = import.meta.env.VITE_INFURA_API_KEY || '';

/** RPCs por chainId (ordem: públicos primeiro para funcionar em produção sem Infura). */
export const PUBLIC_RPC_BY_CHAIN = {
  '0x1': ['https://ethereum-rpc.publicnode.com', 'https://eth.llamarpc.com', 'https://rpc.ankr.com/eth'],
  '0x89': ['https://polygon-bor-rpc.publicnode.com', 'https://rpc.ankr.com/polygon', 'https://polygon-rpc.com'],
  '0xa4b1': ['https://arbitrum-one-rpc.publicnode.com', 'https://rpc.ankr.com/arbitrum', 'https://arb1.arbitrum.io/rpc'],
  '0x2105': [
    'https://mainnet.base.org',
    'https://base.llamarpc.com',
    `https://base-mainnet.infura.io/v3/${INFURA_API_KEY}`,
  ],
  '0x14a34': [
    'https://sepolia.base.org',
    `https://base-sepolia.infura.io/v3/${INFURA_API_KEY}`,
  ],
  '0xaa36a7': [
    'https://rpc.sepolia.org',
    'https://ethereum-sepolia-rpc.publicnode.com',
    `https://sepolia.infura.io/v3/${INFURA_API_KEY}`,
  ],
};

const DEFAULT_CHAIN = '0x1';

/**
 * Retorna lista de URLs RPC para o chainId.
 * @param {string|number|null|undefined} chainId
 * @param {boolean} infuraFirst - se true, URLs Infura vêm primeiro (ex.: WalletContext)
 * @returns {string[]}
 */
export function getRpcUrls(chainId, infuraFirst = false) {
  const key = normalizeChainId(chainId) || DEFAULT_CHAIN;
  const urls = PUBLIC_RPC_BY_CHAIN[key] || PUBLIC_RPC_BY_CHAIN[DEFAULT_CHAIN] || [];
  if (!infuraFirst) return [...urls];
  const infura = urls.filter((u) => u.includes('infura'));
  const rest = urls.filter((u) => !u.includes('infura'));
  return [...infura, ...rest];
}
